export default "__VITE_ASSET__ea264184__"